import React from 'react';

/*
 * 문구 안의 가벼운 표기를 렌더링한다.
 *   **text** → 굵게,  ==text== → 옅은 강조,  \n\n → 문단 나눔
 */

const TOKEN = /(\*\*[^*]+\*\*|==[^=]+==)/g;

export function renderRich(text) {
  return text.split(TOKEN).map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return (
        <strong key={i} className="font-semibold text-stone-900">
          {part.slice(2, -2)}
        </strong>
      );
    }
    if (part.startsWith('==') && part.endsWith('==')) {
      // 바깥 여백(-mx)으로 패딩만큼 당겨서, 뒤에 붙는 조사가 띄어 쓴 것처럼 보이지 않게 한다
      return (
        <mark key={i} className="-mx-0.5 rounded-sm bg-sky-100/80 px-0.5 font-medium text-sky-900 box-decoration-clone">
          {part.slice(2, -2)}
        </mark>
      );
    }
    return part;
  });
}

export default function Rich({ text, paragraphs = false, className }) {
  if (!paragraphs) return <>{renderRich(text)}</>;
  return (
    <>
      {text.split('\n\n').map((p, i) => (
        <p key={i} className={className}>
          {renderRich(p)}
        </p>
      ))}
    </>
  );
}
